import { FlaskConical } from 'lucide-react';
import { useDemoPersistStore } from '../store/demoPersist.store';

export default function DemoPersistToast() {
  const message = useDemoPersistStore((s) => s.message);
  if (!message) return null;

  return (
    <div
      role="alert"
      className="fixed bottom-[max(1.5rem,env(safe-area-inset-bottom))] left-1/2 -translate-x-1/2 z-[60] max-w-md w-[calc(100%-2rem)] bg-amber-950 text-amber-50 px-4 py-3 rounded-xl shadow-lg flex items-start gap-2.5 text-sm font-medium"
    >
      <FlaskConical size={18} className="shrink-0 mt-0.5 text-amber-300" aria-hidden />
      <p>{message}</p>
    </div>
  );
}
